import { RefObject, useEffect } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { SDK } from 'sdk';

import { useOnVisibleDocument } from './useOnVisibleDocument';

export const useOnMarkRead = (sdk: SDK, ref: RefObject<Scrollbars>): void => {
	const documentIsVisible = useOnVisibleDocument();
	useEffect(() => {
		const el = ref.current;
		if (el && sdk.uiStateStore.opened && el.getClientHeight() === el.getScrollHeight() && documentIsVisible) {
			sdk.eventsStore.markRead();
		}
	}, [sdk.eventsStore.dialogEventsForRender.length, sdk.uiStateStore.opened, sdk, ref, documentIsVisible]);

	useEffect(() => {
		const fn = (): void => {
			const el = ref.current;
			if (
				el &&
				documentIsVisible &&
				sdk.uiStateStore.opened &&
				el.getScrollHeight() - el.getScrollTop() <= el.getClientHeight() + 1
			) {
				sdk.eventsStore.markRead();
			}
		};
		document.addEventListener('visibilitychange', fn);
		return (): void => {
			document.removeEventListener('visibilitychange', fn);
		};
	}, [documentIsVisible, ref, sdk.eventsStore, sdk.uiStateStore.opened]);
};
